import { boot } from 'quasar/wrappers';
import axios, { AxiosInstance } from 'axios';
import { initialize as initAuth } from 'src/store/jwt';
import { Answer } from 'src/store/models';
import { isObject, isString } from 'lodash';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const apiUrl = process.env.API_URL;
const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

async function sendQuery<T=unknown>(data: unknown): Promise<T> {
  const ans = (await api.post<Answer>('/rpc', data, {})).data;
  if (isObject(ans) && 'result' in ans){
    return ans.result as T
  }else{
    throw new Error(ans.failure)
  }
}


export default boot(({ app }) => {
  initAuth();

  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios;
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api;
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
});

export { api, sendQuery };
